import { PAID_REFERRALS_V2 } from "../../constants/featureFlags";

export const LEGACY_LIST_PATH = "/paid-leads";
export const PAID_REFERRALS_PATH = "/paid-referrals";

/**
 * Where the Paid Leads / Paid Referrals list (and, under it, a request's detail page) lives. GROWTH-7922: the flag decides, so
 * every navigate, link and "am I on the detail page" check moves together instead of each keeping its own copy of the path.
 *
 * @returns {string}
 */
export const getPaidLeadsBasePath = () => (PAID_REFERRALS_V2 ? PAID_REFERRALS_PATH : LEGACY_LIST_PATH);
